import { useEffect, useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { getPrincipalMessage } from "../Service/Api";

const PrincipalMessage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);

  const emptyArray = [];

  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Director's Message", link: "/DirectorMessage" },
        { label: "Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },
    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

    {
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];

  const vicePrincipalMessages = data.filter(
    (item) => item.category === "Vice Principal",
  );

  // Find Ruchi's message and separate the rest
  const ruchiMessage = vicePrincipalMessages.find(
    (msg) => msg.name === "Mrs Ruchi Joshi",
  );
  const otherMessages = vicePrincipalMessages.filter(
    (msg) => msg.name !== "Mrs Ruchi Joshi",
  );

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-about-4.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Leadership Board"
                breadEnd="Leadership Board"
                breadMid="Leadership Board"
              />
              {/* <h4 className="color-red">PRINCIPAL</h4>
              <div class="wt-media">
                <div class="lazyload-wrapper ">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/RUCHI-JOSHI.jpeg"
                    alt="RUCHI JOSHI"
                    class="img-fluid"
                  />
                </div>
              </div>
              <h5 class="color-green">RUCHI JOSHI</h5>
              <br />
              <p class="custom-message">
                A progressive education leader, Ms Ruchi Joshi has pioneered
                innovative ideas and transformative practices all through her
                professional journey of over two decades. Her teaching
                repertoire is enriched with a gamut of experiences at
                institutions across the country, including NCR & the North-East
                of India. Her student years at St Mary’s Convent, Allahabad;
                DAV, Srinagar; & Allahabad University; have deeply shaped her
                worldview.
              </p>
              <p class="custom-message">
                Widely recognized for her creative verve and leadership acumen,
                Ms Joshi has helmed key positions including HOD, English
                department; Academic Coordinator, Middle School; and
                Coordinator, School events; at KR Mangalam World School, GK2,
                prior to joining Lotus Valley International School, Gurugram, as
                Vice Principal in the year 2014. As the School’s first Vice
                Principal, she played a significant role in guiding the senior
                school’s journey during its formative years through prolific
                contributions towards curriculum design & enrichment, and
                assessment & evaluation strategies.
              </p>
              <p class="custom-message">
                Ms Joshi is extensively associated with CBSE initiatives and has
                spearheaded the implementation of SQAAF (School Quality
                Assessment & Assurance framework) at Lotus Valley. She has
                successfully organised JEE, CTET, NEET & CBSE exams as Centre
                Superintendent and mentored several batches of students for the
                CBSE exams.
              </p>
              <p class="custom-message">
                Innovative practices and experiential learning fuel Ms Joshi’s
                pedagogical approach. This finds reflection in her classes
                wherein books are celebrated, art and films appreciated, and
                diverse perspectives and opinions find a platform. Ms Joshi has
                passionately built love for literature in her students through
                an eclectic blend of strategies. Her lesson plans based on
                cartoons and stereotypes have been included by the British
                Council in its publication on Core Skills.
              </p>
              <p class="custom-message">
                A strong believer in individual uniqueness, she is committed to
                empowering & enabling her students to be future-ready. Her
                collaboration with young minds has provided a fillip to several
                artistic endeavours and signature events at Lotus Valley
                including the School’s first multilingual event, ‘Mélange’, book
                week, ‘Eclectique’, literary fest ‘Eloquence’, leadership summit
                ‘The Learners Conclave’, among others.
              </p>
              <p class="custom-message">
                In all her pursuits, Ms Joshi aspires to nurture a thinking
                mind, and a conscientious individual. She is of the fervent view
                that the <i> ‘Energy of the mind is the essence of Life.’</i>
              </p> */}

              <br />
              <br />
              <h4 className="color-red">VICE PRINCIPAL (SENIOR WING)</h4>
              <br />
              <div class="wt-media">
                <div class="lazyload-wrapper ">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/MONIKA-JASROTIA.jpeg"
                    alt="RUCHI JOSHI"
                    class="img-fluid"
                  />
                </div>
              </div>

              <h5 class="color-green">MONIKA JASROTIA</h5>
              <p class="custom-message">
                With over 23 years of rich experience in Senior School
                education, Ms. Monika Jasrotia is a seasoned educator and a
                leader committed to academic excellence and inclusive
                development.
              </p>
              <p class="custom-message">
                Ms. Jasrotia began her journey in the field of education at Don
                Bosco Public School, Nainital—a reputed residential
                institution—where she played key roles in the Department of
                Science and residence halls administration. She later moved to
                Sherwood Convent, where she efficiently handled academics,
                science exhibitions, CBSE and private examinations. As a gold
                medalist in Life Sciences, her strong academic background in the
                Medical stream of Science has enabled her to guide students into
                top medical colleges, including AIIMS.
              </p>
              <p class="custom-message">
                As a member of the Lotus Valley International School family for
                nearly 13 years, Ms. Jasrotia has served in various leadership
                capacities—as Academic Coordinator, Headmistress, and currently,
                Vice Principal (Senior Wing). She has also led as the Head of
                Science Department for over a decade at Lotus Valley and has
                worked closely with CBSE on multiple academic initiatives.
              </p>
              <p class="custom-message">
                One of her key achievements includes serving as the National
                Coordinator for the CBSE National Science Exhibition hosted by
                Lotus Valley in 2023, which saw participation from 485 schools
                across India.
              </p>
              <p class="custom-message">
                A passionate Biology educator, Ms. Jasrotia brings innovation,
                relevance, and energy to her teaching. Her classrooms are
                dynamic spaces where learners interact, involve and innovate,
                stay up-to-date with scientific advancements and real-world
                applications.
              </p>
              <p class="custom-message">
                She firmly believes that school plays a pivotal role in shaping
                students’ minds, attitudes, and future paths through the right
                guidance. She recognises the immense responsibility educators
                hold and is committed to upholding it with dedication and care.
              </p>
              <p class="custom-message">
                Her leadership philosophy is deeply rooted in discipline, hard
                work, logical and critical thinking, empathetic understanding,
                and the imparting of strong moral values—qualities she believes
                are essential for student success and lifelong excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrincipalMessage;
